export default "/images/e1a4746952c0948db0db283a20e98e6c.avif";